<template>
     <div class="invate-box" >
            <div class="invate-bg"></div>
            <div class="invate-content">
                <div class="invate-header">
                    <div class="invate-title"></div>
                    <div class="invate-right">
                        <div class="invate-tab">
                            <div class="invate-tab-item " :class="{ active: tab == 1 }" @click="choseTab(1)">央企</div>
                            <div class="invate-tab-item" :class="{ active: tab == 2 }" @click="choseTab(2)">地方</div>
                        </div>
                        <div class="invate-close" @click="handleCloseCX"></div>
                    </div>

                </div>
                <div class="invate-body">
                    <div class="invate-yq" v-show="tab == 1">
                        <swiper class="carouse-yq" ref="yqSwper" :options="yqswiperOptions">
                            <swiper-slide class="carouse-yq-item" v-for="(item, index) in qy_data" :key="index">
                                <div class="yq-item" v-for="childItem in item" :key="childItem.id">
                                    <div class="cp-pic">
                                        <img :src="`/images/yq/${childItem.tp_url}.jpg`" class="cp-img" alt="">
                                    </div>
                                    <div class="cp-content">
                                        <el-scrollbar>
                                            <p>产品名称：{{ childItem.cpmc }}</p>
                                            <p>企业名称：{{ childItem.qymc }}</p>
                                            <p class="cp-je">产品简介：{{ childItem.cpje }}</p>
                                        </el-scrollbar>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-button-yqprev" slot="button-prev"></div>
                            <div class="swiper-button-yqnext" slot="button-next"></div>

                        </swiper>

                    </div>
                    <div class="invate-df" v-show="tab == 2">
                        <div class="area-box">
                            <span class="area-name" :class="{ active: nowIndex == index || nowIndex == index + 1 }"
                                @click="choseArea(index)" v-for="(item, index) in df_data" :key="index">{{ item.sf }}</span>
                        </div>
                        <div class="area-carouse-box">
                            <swiper class="swiper" ref="mySwiper" :slides-per-view="2" :options="swiperOptions">
                                <swiper-slide class="carouse-df-item" v-for="(item, index) in df_data" :key="index">
                                    <div class="df-title">{{ item.sf }}</div>
                                    <div class="df-content-box">
                                        <el-scrollbar>
                                            <div class="sf-item" v-for="childItem in item.children" :key="childItem.id">
                                                <div class="cp-pic">
                                                    <img :src="`/images/df/${childItem.tp_url}.jpg`" class="df-img" alt="">
                                                </div>
                                                <div class="cp-content">
                                                    <el-scrollbar>
                                                        <p>产品名称：{{ childItem.cpmc }}</p>
                                                        <p>企业名称：{{ childItem.qymc }}</p>
                                                        <p class="cp-je">产品简介：{{ childItem.cpje }}</p>
                                                    </el-scrollbar>
                                                </div>
                                            </div>
                                        </el-scrollbar>
                                    </div>
                                </swiper-slide>
                                <div class="swiper-button-prev" slot="button-prev"></div>
                                <div class="swiper-button-next" slot="button-next"></div>

                            </swiper>

                        </div>
                    </div>
                </div>
            </div>

        </div>
</template>
<script>
import { cx_yq, cx_df } from "@/utils/innvateData"
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default({
    components: {
        Swiper,
        SwiperSlide
    },
    computed: {
        swiper() {
        
            return this.$refs.mySwiper.$swiper;
        },
        yqSwper() {
            return this.$refs.yqSwiper.$swiper;
        }
    },
    data() {
        return {
            tab: 1,
            qy_data: [],
            df_data: [],
            nowIndex: 1,
            swiperOptions: {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                slidesPerView: 2,
                spaceBetween: 20,
                touchStartPreventDefault: false,
                on: {
                    slideChange: (swiper) => {

                        this.nowIndex = this.swiper.activeIndex + 1
                    },
                },
            },
            yqswiperOptions: {

                lazy: true,

                // simulateTouch:false,
                touchStartPreventDefault: false,
                navigation: {
                    nextEl: ".swiper-button-yqnext",
                    prevEl: ".swiper-button-yqprev",
                },


            },
        }
    },
    methods: {
        choseTab(num) {
            this.tab = num
        },
        choseArea(num) {
            this.nowIndex = num;
           
            this.swiper.slideTo(num, 0.5, true);
        },
     
        handleCloseCX() {
            this.tab = 1;
            this.nowIndex = 1;
            this.$emit("close")
        }
    },
    mounted() {
        for (var i = 0, len = cx_yq.length; i < len; i += 6) {
            this.qy_data.push(cx_yq.slice(i, i + 6));
        }
        this.df_data = cx_df;

    },
})
</script>

<style lang="scss" scoped>
@mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.invate-box {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;

        .invate-bg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba($color: #000000, $alpha: 0.7);
        }

        .invate-content {
            width: 1250px;
            height: 746px;
            background-image: url("../../assets/img/chuangxin/bg.png");
            @include background-com();
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);


            .invate-header {
                width: 100%;
                height: 87px;
                padding-left: 40px;
                padding-right: 27px;
                display: flex;

                justify-content: space-between;
                align-items: center;
            }

            .invate-title {
                width: 224px;
                height: 45px;
                background-image: url("../../assets/img/chuangxin/title.png");
                @include background-com();
            }

            .invate-right {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .invate-close {
                width: 40px;
                height: 40px;
                background-image: url("../../assets/img/chuangxin/close.png");
                @include background-com();
                cursor: pointer;
            }

            .invate-tab {
                display: flex;
                margin-right: 48px;
                margin-top: 5px;

                .invate-tab-item {
                    font-size: 28px;
                    width: 106px;
                    height: 61px;
                    line-height: 52px;
                    text-align: center;
                    color: #ffffff;
                    font-weight: bold;
                    cursor: pointer;
                    margin-left: 10px;

                    &.active {
                        @include background-com();
                        background-image: url("../../assets/img/chuangxin/tab-active.png");
                    }
                }
            }

            .invate-body {
                width: 100%;
                height: calc(100% - 87px);

                .swiper-button-prev,
                .swiper-button-yqprev,
                .swiper-button-next,
                .swiper-button-yqnext {
                    width: 34px;
                    height: 34px;
                    position: absolute;
                    @include background-com();
                    top: 50%;
                    margin-top: -17px;
                    cursor: pointer;
                    z-index: 10;

                    &::after {
                        display: none;
                    }

                    &.swiper-button-disabled {
                        opacity: 0.35;
                        cursor: auto;
                    }
                }

                .swiper-button-prev,
                .swiper-button-yqprev {
                    background-image: url("../../assets/img/chuangxin/arrow-left.png");
                }

                .swiper-button-next,

                .swiper-button-yqnext {
                    right: 20px;
                    background-image: url("../../assets/img/chuangxin/arrow-right.png");
                }

                .invate-yq {
                    width: 100%;
                    height: 100%;
                    padding-top: 75px;

                }

                .carouse-yq {
                    height: 100%;

                }

                .carouse-yq-item {
                    display: flex;
                    padding: 10px 40px;
                    flex-wrap: wrap;
                }

                .yq-item {
                    width: 50%;
                    padding-bottom: 20px;

                    display: flex;
                    position: relative;
                    height: 160px;
                    padding-left: 10px;
                    margin-bottom: 15px;

                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        bottom: 0;
                        width: 80%;
                        height: 3px;
                        left: 50%;
                        transform: translate(-50%, 0);
                        background-image: url("../../assets/img/chuangxin/border.png");
                        @include background-com();
                    }

                    &:nth-child(5) {
                        &::after {
                            display: none;
                        }
                    }

                    &:nth-child(6) {
                        &::after {
                            display: none;
                        }
                    }

                    .cp-pic {
                        width: 197px;
                        height: 140px;
                        flex-shrink: 0;
                        overflow: hidden;
                        background-color: #ffffff;

                        img {
                            height: 100%;
                            width: 100%;
                            object-fit: cover;
                        }
                    }

                    .cp-content {
                        height: 100%;
                        color: #d72e10;
                        font-size: 14px;
                        text-align: left;
                        padding-left: 10px;
                        overflow-x: hidden;

                        p {
                            margin-bottom: 15px;
                            line-height: 1.5;
                        }
                    }
                }

                .invate-df {
                    width: 100%;
                    height: 100%;
                    padding-top: 10px;
                    padding-left: 30px;
                    padding-right: 30px;
                    display: flex;
                    flex-direction: column;
                }

                .area-box {
                    width: 780px;
                    height: 80px;
                    text-align: center;
                    word-wrap: break-word;
                    margin: 0 auto;
                    margin-bottom: 15px;

                    .area-name {
                        color: #891500;
                        font-size: 14px;
                        padding: 0 5px;
                        line-height: 30px;
                        border-right: 1px solid #891500;
                        cursor: pointer;

                        &.active {
                            text-decoration: underline;
                        }
                    }
                }

                .area-carouse-box {
                    width: 100%;
                    height: calc(100% - 80px);
                    padding-bottom: 20px;
                }

                .carouse-df-item {

                    height: 100%;
                    width: calc(50% - 30px);
                    overflow: hidden;

                    .df-title {
                        width: 100%;
                        height: 44px;
                        background-image: url("../../assets/img/chuangxin/title-bg.png");
                        @include background-com();
                        text-align: center;
                        font-size: 36px;
                        color: #d72e10;
                        line-height: 44px;
                    }

                    .df-content-box {
                        height: 100%;
                        width: 100%;
                        overflow: hidden;
                        padding: 0 20px;
                    }

                    .sf-item {
                        height: 175px;
                        width: calc(100% - 20px);
                        display: flex;
                        padding: 15px 0;
                        position: relative;

                        &::after {
                            content: "";
                            display: block;
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            height: 3px;
                            left: 50%;
                            transform: translate(-50%, 0);
                            background-image: url("../../assets/img/chuangxin/border.png");
                            @include background-com();
                        }

                        &:last-child {
                            &::after {
                                display: none;
                            }
                        }

                        .cp-pic {
                            width: 145px;
                            height: 145px;
                            flex-shrink: 0;
                            overflow: hidden;
                            background-color: #ffffff;

                            img {
                                height: 100%;
                                width: 100%;
                                object-fit: cover;
                            }
                        }

                        .cp-content {
                            height: 100%;
                            color: #d72e10;
                            font-size: 14px;
                            text-align: left;
                            padding-left: 10px;
                            overflow-x: hidden;

                            p {
                                margin-bottom: 15px;
                                line-height: 1.5;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<style>
.cp-content .el-scrollbar__wrap {
    overflow-x: hidden;
}



.area-carouse-box .swiper-container,
.invate-yq .swiper-container {
    height: 100%;
    padding: 0 40px;
}
</style>